import { useCallback, useEffect, useRef } from 'react';

export default function useAnimationFrame(callback: (dt:number) => void): void
{
  const frame = useRef(-1);
  const last = useRef(performance.now());

  const animate = useCallback(() =>
  {
    const now = performance.now();
    const delta = (now - last.current) / 1000;
    // In seconds ~> you can do ms or anything in userland
    callback(delta);
    last.current = now;
    frame.current = requestAnimationFrame(animate);
  }, [callback]);

  useEffect(() => {
    frame.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame.current);
  }, [animate]); // Make sure to change it if the deps change
}